// src/pages/IndoorMap/stepIcons.js
import { LogIn, LogOut, Footprints, CornerUpRight, Navigation, ArrowRight, DoorOpen } from "lucide-react"

const ICON_RULES = [
  { test: /\benter\b/i, Icon: LogIn },
  { test: /\bexit\b/i, Icon: LogOut },
  { test: /\bwalk\b/i, Icon: Footprints },
  { test: /\bturn\b/i, Icon: CornerUpRight },
  { test: /\bfollow\b/i, Icon: Navigation },
  { test: /reached|reach\b/i, Icon: DoorOpen },
  { test: /\bcontinue\b/i, Icon: ArrowRight },
]

export function getStepIcon(text) {
  const match = ICON_RULES.find(rule => rule.test.test(text))
  return match ? match.Icon : ArrowRight
}